var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 24,
    viewBox: "0 0 235 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21728 21.3467C14.3854 21.3467 16.7627 18.6852 16.8144 16.0494C16.8919 12.7419 14.5921 10.9589 9.37232 10.2612C5.36704 9.71853 5.57377 8.58155 5.59961 8.11642C5.70297 6.72103 7.66685 6.51431 8.85551 6.51431C10.3026 6.54015 12.1889 6.85023 12.3698 8.60739H16.1167C15.9358 5.22228 13.2742 3.02584 8.95887 3C4.74687 3 1.98194 4.93804 1.74937 8.06474C1.38761 12.7935 6.99499 13.5946 8.82967 13.853C11.1812 14.1889 12.1631 14.6541 12.5765 15.0158C12.8866 15.2742 13.0417 15.636 13.0417 16.0494C13.0417 17.7291 10.3543 17.8066 9.21728 17.8066C6.14226 17.8066 5.212 16.3854 4.97944 15.7135H1C1.28425 19.848 5.65129 21.3467 9.21728 21.3467Z",
    fill: "#28293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9172 21.2175V3.1292H36.5321L30.227 15.4551L23.9219 3.1292H20.5368V21.2175H24.1545V11.6566L29.2451 21.2175H31.2089L36.2995 11.6566V21.2175H39.9172Z",
    fill: "#28293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5485 21.2175H46.2437L48.0525 17.2898H56.4765L58.2853 21.2175H61.9547L53.5048 3.1292H51.0242L42.5485 21.2175ZM52.2645 8.14226L55.0294 14.1373H49.4996L52.2645 8.14226Z",
    fill: "#28293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3512 3.1292V21.2175H67.9689V15.0675H71.6899L76.0828 21.2175H80.3206L75.566 14.499C77.7624 13.6463 79.0286 11.7341 79.0286 9.09836C79.0286 3.90442 74.6357 3.1292 72 3.1292H64.3512ZM71.9225 6.51431C74.7907 6.51431 75.3851 7.54793 75.3851 9.09836C75.3851 10.6746 74.7907 11.7082 71.9225 11.7082H67.9689V6.51431H71.9225Z",
    fill: "#28293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4407 6.48847V21.2175H91.0583V6.48847H96.9758V3.1292H81.5232V6.48847H87.4407Z",
    fill: "#28293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.395 12.5093C107.395 18.3751 110.031 21.3467 115.199 21.3467C120.367 21.3467 123.002 18.3751 123.002 12.5093L123.028 3.1292H119.385L119.359 12.3543C119.359 16.4887 118.274 17.9616 115.199 17.9616C112.124 17.9616 111.038 16.4887 111.038 12.3543L111.064 3.1292H107.421L107.395 12.5093Z",
    fill: "#28293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M131.342 6.48847V21.2175H134.96V6.48847H140.877V3.1292H125.425V6.48847H131.342Z",
    fill: "#28293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.71 21.2175V3.1292H144.092V21.2175H147.71Z",
    fill: "#28293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.886 21.2175V17.8583H156.428V3.1292H152.81V21.2175H165.886Z",
    fill: "#28293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.553 21.2175V3.1292H168.935V21.2175H172.553Z",
    fill: "#28293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.685 6.48847V21.2175H185.302V6.48847H191.22V3.1292H175.767V6.48847H181.685Z",
    fill: "#28293D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M198.052 21.2175V3.1292H194.434V21.2175H198.052Z",
    fill: "#28293D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M203.153 21.2175H216.719V17.8583H206.771V13.853H216.022V10.4937H206.771V6.48847H216.383V3.1292H203.153V21.2175Z",
    fill: "#28293D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.205 21.3467C232.373 21.3467 234.75 18.6852 234.802 16.0494C234.88 12.7419 232.58 10.9589 227.36 10.2612C223.355 9.71853 223.562 8.58155 223.587 8.11642C223.691 6.72103 225.655 6.51431 226.843 6.51431C228.29 6.54015 230.177 6.85023 230.358 8.60739H234.104C233.924 5.22228 231.262 3.02584 226.947 3C222.735 3 219.97 4.93804 219.737 8.06474C219.375 12.7935 224.983 13.5946 226.817 13.853C229.169 14.1889 230.151 14.6541 230.564 15.0158C230.874 15.2742 231.029 15.636 231.029 16.0494C231.029 17.7291 228.342 17.8066 227.205 17.8066C224.13 17.8066 223.2 16.3854 222.967 15.7135H218.988C219.272 19.848 223.639 21.3467 227.205 21.3467Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupLogo);
export default __webpack_public_path__ + "static/media/SUPLogo.4079e4889516575be8b01c935bd94d05.svg";
export { ForwardRef as ReactComponent };